import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import ReactDOM from 'react-dom/client';

import App from './App';

// O monitoramento de erros so e iniciado quando ha chave configurada.
// Sem essa verificacao o Bugsnag lanca "No Bugsnag API Key set" e a aplicacao
// nem chega a montar, o que impede rodar o projeto em ambiente local.
// Em dev e producao, onde a chave existe, o comportamento e o mesmo de sempre.
const bugsnagApiKey = process.env.REACT_APP_BUGSNAG_API_KEY;

let arvore = <App />;

if (bugsnagApiKey) {
  Bugsnag.start({
    apiKey: bugsnagApiKey,
    plugins: [new BugsnagPluginReact()],
  });
  BugsnagPerformance.start({ apiKey: bugsnagApiKey });

  const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
  arvore = (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(arvore);
